<template>
  <div>
    <NavBar class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <v-main class="overflow-hidden">


          <div class="d-flex h-100   flex-column">
            <v-stepper v-model="loginStepper">
              <v-stepper-header>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="p-2" step="1">
                  <div class="row">
                    <h1 class="col-12 text-center p-0 ">
                      خریدار می شوید یا فروشنده؟
                    </h1>
                    <div class="col-12  pb-1 ">
                      <div class="bg-white rounded-lg pointer" @click="loginStepper = 2">
                        <div class="row mx-1">
                          <div class="col-5 py-4"><i
                              class="fa-solid fa-arrow-right-to-bracket fa-rotate-180 fa-2xl primary-text"></i></div>
                          <div class="col-7 py-4 font16px primary-text pr-6">ورود</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12  py-0" @click="loginStepper = 4">
                      <div class="bg-white rounded-lg pointer">
                        <div class="row mx-1">
                          <div class="col-5 py-4"><i class="fa-solid fa-user-plus fa-2xl primary-text"></i></div>
                          <div class="col-7 py-4 font16px primary-text">خریدارم</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12  pt-1 " @click="loginStepper = 6">
                      <div class="bg-white rounded-lg pointer">
                        <div class="row mx-1">
                          <div class="col-5 py-4"><i class="fa-solid fa-store fa-2xl primary-text"></i></div>
                          <div class="col-7 py-4 font16px primary-text">فروشندم</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <span class="font-weight-bold primary-text"> خریدار: </span><span class="primary-text">محصول میبینم خواستم میخرم،نقد میکنم</span>
                    </div>
                    <div class="col-12 ">
                      <span class="font-weight-bold primary-text">فروشنده: </span><span class="primary-text">محصول عرضه میکنم،نقد میشنوم، بهبود میدم</span>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="2">
                  <v-form ref="loginForm" class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 1"></i>
                    </div>
                    <div class="col-12">
                      ورود <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">کاربر محترم برای ورود لطفا شماره موبایل خود را وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto">
                      <v-text-field
                          v-model="loginPhoneNumber"
                          :rules="phoneNumberRules"
                          class="rounded-lg"
                          flat
                          solo
                          type="number">
                      </v-text-field>
                    </div>
                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn block class="rounded-lg white--text" color="primary" @click="getVerifyCode()">
                        ورود
                      </v-btn>
                    </div>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="3">
                  <div class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 2"></i>
                    </div>
                    <div class="col-12">
                      ورود <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">کد پیامک شده را جهت ورود وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto " dir="ltr">
                      <v-otp-input
                          v-model="loginOtp"
                          :length="6"
                          class="rounded-lg otp-style"
                          plain
                      ></v-otp-input>
                    </div>

                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn :disabled="loginOtp.length !== 6" block class="rounded-lg white--text" color="primary"
                             @click="login(1)">
                        ورود
                      </v-btn>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="4">
                  <v-form ref="buyerRegisterForm" class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 1"></i>
                    </div>
                    <div class="col-12">
                      ثبت نام خریدار <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">خریدار محترم برای ثبت نام لطفا شماره موبایل خود را وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto">
                      <v-text-field
                          v-model="buyerPhoneNumber"
                          :rules="phoneNumberRules"
                          class="rounded-lg"
                          flat
                          solo>
                      </v-text-field>
                    </div>
                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn block class="rounded-lg white--text" color="primary" @click="buyerRegister">
                        ثبت نام
                      </v-btn>
                    </div>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="5">
                  <div class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 4"></i>
                    </div>
                    <div class="col-12">
                      ثبت نام خریدار <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">کد پیامک شده را جهت ورود وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto " dir="ltr">
                      <v-otp-input
                          v-model="buyerOtp"
                          :length="6"
                          class="rounded-lg otp-style"
                          plain
                      ></v-otp-input>
                    </div>

                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn :disabled="buyerOtp.length !== 6" block class="rounded-lg white--text" color="primary"
                             @click="register(4)">
                        تکمیل ثبت نام
                      </v-btn>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="6">
                  <v-form ref="sellerRegisterForm" class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 1"></i>
                    </div>
                    <div class="col-12">
                      ثبت نام فروشنده <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">فروشنده محترم برای ثبت نام لطفا شماره موبایل خود را وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto">
                      <v-text-field
                          v-model="sellerPhoneNumber"
                          :rules="phoneNumberRules"
                          class="rounded-lg"
                          flat
                          solo>
                      </v-text-field>
                    </div>
                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn block class="rounded-lg white--text" color="primary" @click="sellerRegister">
                        ثبت نام
                      </v-btn>
                    </div>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="p-2" step="7">
                  <div class="row">
                    <div class="col-12 py-0"><i class="fa-solid fa-arrow-right fa-2xl pointer"
                                                @click="loginStepper = 4"></i>
                    </div>
                    <div class="col-12">
                      ثبت نام فروشنده <i class="fa-solid fa-arrow-right-to-bracket fa-rotate-180"></i></div>
                    <div class="col-12">کد پیامک شده را جهت ورود وارد نمایید</div>
                    <div class="col-12 col-sm-7 mx-auto " dir="ltr">
                      <v-otp-input
                          v-model="sellerOtp"
                          :length="6"
                          class="rounded-lg otp-style"
                          plain
                      ></v-otp-input>
                    </div>

                    <div class="col-12 pt-0 col-sm-7 mx-auto">
                      <v-btn :disabled="sellerOtp.length !== 6" block class="rounded-lg white--text" color="primary"
                             @click="register(3)">
                        تکمیل ثبت نام
                      </v-btn>
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
            <div class="mt-auto">
              <div class="col-12 font12px">با ورود یا ثبت نام در ایوان خانه شما <span
                  class="text-decoration-underline font12px"> شرایط و قوانین </span> استفاده از سرویس های سایت ایوان
                خانه و
                قوانین <span class="text-decoration-underline font12px">  حریم خصوصی </span> آن را می پذیرد.
              </div>
            </div>

          </div>
        </v-main>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"
    >
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  name: "LoginRegister",
  metaInfo: {
    title: 'ایوان خانه- ورود/ثبت نام',
  },
  components: {NavBar},
  data() {
    return {
      showLoaderDialog: false,
      showResult: false,
      resultText: '',
      loginStepper: 1,
      loginOtp: '',
      buyerOtp: '',
      sellerOtp: '',
      phoneNumberRules: [
        v => !!v || 'شماره موبایل اجباری است',
        value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
        value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
      ],
      sellerPhoneNumber: null,
      buyerPhoneNumber: null,
      loginPhoneNumber: null,
    }
  },
  methods: {
    getVerifyCode() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.loginPhoneNumber);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Home/RecoveryPassword", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.loginStepper = 3
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    login(type) {
      this.$refs.loginForm.validate()
      if (this.$refs.loginForm.validate() || type !== 1) {

        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        if (type === 1) {
          urlencoded.append("PhoneNumber", this.loginPhoneNumber);
          urlencoded.append("Password", this.loginOtp);
        } else if (type === 4) {

          urlencoded.append("PhoneNumber", this.buyerPhoneNumber);
          urlencoded.append("Password", this.buyerOtp);
        } else if (type === 3) {
          urlencoded.append("PhoneNumber", this.sellerPhoneNumber);
          urlencoded.append("Password", this.sellerOtp);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null;
        fetch(this.$baseUrl + "Home/Login", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              if (resStatus === 200) {

                let json = JSON.parse(result)
                if (json.Role === 4) {
                  // this.getClientLikeList();
                  if (type === 4) {
                    this.$setUserData(this.buyerPhoneNumber, this.buyerOtp, 'Bearer ' + json.JwtToken, json.Role,json.AppUserId);
                  } else if(type ===1){
                    this.$setUserData(this.loginPhoneNumber, this.loginOtp, 'Bearer ' + json.JwtToken, json.Role,json.AppUserId);
                  }
                  this.getBuyerProductBookMark()
                  this.getBuyerFollowing()
                  this.getBuyersPostsLikes()
                  this.getBuyersPostBookmark()
                  this.$router.replace({path: 'BuyerProfile'})
                } else if (json.Role === 3) {
                  // this.getVendorLikeList();
                  if (type === 3) {
                    this.$setUserData(this.sellerPhoneNumber, this.sellerOtp, 'Bearer ' + json.JwtToken, json.Role,json.AppUserId);
                  } else if(type ===1){
                    this.$setUserData(this.loginPhoneNumber, this.loginOtp, 'Bearer ' + json.JwtToken, json.Role,json.AppUserId);
                  }
                  this.getSellerProductBookMark()
                  this.getSellerFollowing()
                  this.getSellerPostsLikes()
                  this.getSellerPostBookmark()
                  this.$router.replace({path: 'SellerProfile'})


                }
                this.$store.commit('setToken', 'Bearer ' + json.JwtToken)
                this.$store.commit('setRole', json.Role)

                this.$store.commit('addProductToCart')

              } else {
                this.resultText = result
                this.showResult = true
              }
              this.showLoaderDialog = false
            })
            .catch(error => console.log('error', error));
      }
    },
    buyerRegister() {
      this.$refs.buyerRegisterForm.validate()
      if (this.$refs.buyerRegisterForm.validate()) {
        this.getVerifyCodeForRegister(4)
      }
    },
    sellerRegister() {
      this.$refs.sellerRegisterForm.validate()
      if (this.$refs.sellerRegisterForm.validate()) {
        this.getVerifyCodeForRegister(3)
      }
    },
    register(type) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeRole", type);
      urlencoded.append("IsAccept", true);
      urlencoded.append("ReagentPhoneNumber", "");
      if (type === 4) {
        urlencoded.append("PhoneNumber", this.buyerPhoneNumber);

        urlencoded.append("VeriyMobileCode", this.buyerOtp);
      }
      if (type === 3) {
        urlencoded.append("PhoneNumber", this.sellerPhoneNumber);

        urlencoded.append("VeriyMobileCode", this.sellerOtp);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Home/Register", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.login(type)
            } else {
              this.resultText = result
              this.showResult = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getVerifyCodeForRegister(type) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      if (type === 4) {
        urlencoded.append("PhoneNumber", this.buyerPhoneNumber);
      } else {
        urlencoded.append("PhoneNumber", this.sellerPhoneNumber);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Home/RequestVerfiyMobile", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {

            this.showLoaderDialog = false
            this.showResult = true
            this.resultText = result
            if (resStatus === 200) {
              if (type === 4) {
                this.loginStepper = 5
              } else {
                this.loginStepper = 7
              }
            } else {
              console.log(result)
            }
          })
          .catch(error => console.log('error', error));

    },
    getBuyerProductBookMark() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkProduct/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserBookmark', json)

          })
          .catch(error => console.log('error', error));
    },
    getBuyerFollowing() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserFollowing', json)
          })
          .catch(error => console.log('error', error));
    },
    getBuyersPostsLikes() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Dashboard/ListSocialNetworkLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserPostsLikes', json)
          })
          .catch(error => console.log('error', error));
    },
    getBuyersPostBookmark(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let posts = json.filter(x=>x.TypeBookMark === 3)
            this.$store.commit('addUserPostsBookMarks', posts)

          })
          .catch(error => console.log('error', error));
    },
    getSellerProductBookMark() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkProduct/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserBookmark', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerFollowing() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserFollowing', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerPostsLikes() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Dashboard/ListSocialNetworkLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserPostsLikes', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerPostBookmark(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkVendor/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let posts = json.filter(x=>x.TypeBookMark === 3)
            this.$store.commit('addUserPostsBookMarks', posts)

          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>
